// @flow
import R from 'ramda';

export const SK_ADNETWORK_DATASOURCE = 'skadnetwork-valid-messages'; // TODO: change to finalized SKAdNetwork datasource name

export const EO_PAGEVIEW = 'eo_pageview';
export const EO_SMS_SENT = 'eo_sms_sent';
export const EO_BRANCH_CTA_VIEW = 'eo_branch_cta_view';
export const EO_WEB_SESSION_START = 'eo_web_session_start';
export const EO_WEB_TO_APP_AUTO_REDIRECT = 'eo_web_to_app_auto_redirect';
export const EO_DISMISSAL = 'eo_dismissal';

export const EO_INSTALL = 'eo_install';
export const EO_CLICK = 'eo_click';
export const EO_OPEN = 'eo_open';
export const EO_REINSTALL = 'eo_reinstall';
export const EO_IMPRESSION = 'eo_impression';

export const EO_COMMERCE_EVENT = 'eo_commerce_event';
export const EO_CONTENT_EVENT = 'eo_content_event';
export const EO_USER_LIFECYCLE_EVENT = 'eo_user_lifecycle_event';
export const EO_CUSTOM_EVENT = 'eo_custom_event';

export const EO_INSTALL_BLOCKED = 'eo_install_blocked';
export const EO_CLICK_BLOCKED = 'eo_click_blocked';
export const EO_OPEN_BLOCKED = 'eo_open_blocked';
export const EO_REINSTALL_BLOCKED = 'eo_reinstall_blocked';
export const EO_IMPRESSION_BLOCKED = 'eo_impression_blocked';

export const EO_COMMERCE_EVENT_BLOCKED = 'eo_commerce_event_blocked';
export const EO_CONTENT_EVENT_BLOCKED = 'eo_content_event_blocked';
export const EO_USER_LIFECYCLE_EVENT_BLOCKED =
  'eo_user_lifecycle_event_blocked';
export const EO_CUSTOM_EVENT_BLOCKED = 'eo_custom_event_blocked';

export const INSTALL_COHORT = 'install_cohort';
export const REENGAGEMENT_COHORT = 'reengagement_cohort';
export const COST = 'cost';

// Use plural form for table columns (DASH-1627)
export const CORE_DATASOURCES = {
  [EO_PAGEVIEW]: 'pageviews',
  [EO_SMS_SENT]: 'SMS sent',
  [EO_BRANCH_CTA_VIEW]: 'views',
  [EO_INSTALL]: 'installs',
  [EO_CLICK]: 'clicks',
  [EO_OPEN]: 'opens',
  [EO_REINSTALL]: 'reinstalls',
  [EO_WEB_SESSION_START]: 'web session starts',
  [EO_WEB_TO_APP_AUTO_REDIRECT]: 'web to app redirects',
  [EO_IMPRESSION]: 'impressions',
  [EO_DISMISSAL]: 'journey dismissals'
};

export const STANDARD_DATASOURCES = {
  [EO_COMMERCE_EVENT]: 'commerce event',
  [EO_CONTENT_EVENT]: 'content event',
  [EO_USER_LIFECYCLE_EVENT]: 'user lifecycle event',
  [EO_CUSTOM_EVENT]: 'custom event'
};

export const STANDARD_BLOCKED_DATASOURCES = {
  [EO_COMMERCE_EVENT_BLOCKED]: 'commerce event blocked',
  [EO_CONTENT_EVENT_BLOCKED]: 'content event blocked',
  [EO_USER_LIFECYCLE_EVENT_BLOCKED]: 'user lifecycle event blocked',
  [EO_CUSTOM_EVENT_BLOCKED]: 'custom event blocked'
};

export const COST_DATASOURCE = R.path(
  ['context', 'flipper', 'cost_analytics'],
  window.App
)
  ? {
      [COST]: 'cost'
    }
  : {};

export const FRAUD_SPECIFIC_DATASOURCES = {
  [EO_CLICK_BLOCKED]: '#',
  [EO_INSTALL_BLOCKED]: '#',
  [EO_OPEN_BLOCKED]: '#',
  [EO_REINSTALL_BLOCKED]: '#',
  [EO_IMPRESSION_BLOCKED]: '#'
};

export const UNBLOCKED_FRAUD_DATASOURCES = [
  EO_CLICK,
  EO_INSTALL,
  EO_OPEN,
  EO_REINSTALL,
  EO_IMPRESSION
];

export const ALL_FRAUD_DATASOURCES = [
  ...Object.keys(FRAUD_SPECIFIC_DATASOURCES),
  ...UNBLOCKED_FRAUD_DATASOURCES,

  // commented out standard event datasources because we only wish to show blocked ones in the fraud UI
  // leaving these here for the future in the case that customers wish to see blocked and unblocked standard events
  // Object.keys(STANDARD_DATASOURCES),

  ...Object.keys(STANDARD_BLOCKED_DATASOURCES)
];

export const COHORT_DATASOURCES = {
  [INSTALL_COHORT]: 'Acquisition',
  [REENGAGEMENT_COHORT]: 'Re-engagement'
};

export const SKAN_DATASOURCES = {
  [SK_ADNETWORK_DATASOURCE]: 'downloads'
};

/* ------------
 Aggregations
-------------- */
export const DATASOURCES = {
  ...CORE_DATASOURCES,
  ...STANDARD_DATASOURCES,
  ...COST_DATASOURCE
};

export const CSV_EXPORT_DATASOURCES = {
  ...CORE_DATASOURCES,
  ...STANDARD_DATASOURCES,
  [EO_PAGEVIEW]: 'pageview',
  [EO_SMS_SENT]: 'SMS sent',
  [EO_BRANCH_CTA_VIEW]: 'branch CTA view',
  [EO_DISMISSAL]: 'journey dismissals'
};

/* ------------------------
 PAGE SPECIFIC DATASOURCES
---------------------------
 - Certain tables/charts require a certain set of datasources
 - Eventually add datasources for all tables/charts here for easy viewing and configuration
*/

export const DEEPVIEWS_SUMMARY_SECTION_DATASOURCES = [
  EO_BRANCH_CTA_VIEW,
  EO_CLICK,
  EO_WEB_TO_APP_AUTO_REDIRECT,
  EO_INSTALL,
  EO_OPEN,
  EO_REINSTALL
];

export const JOURNEYS_SUMMARY_SECTION_DATASOURCES = [
  EO_BRANCH_CTA_VIEW,
  EO_CLICK,
  EO_WEB_TO_APP_AUTO_REDIRECT,
  EO_INSTALL,
  EO_OPEN,
  EO_REINSTALL,
  EO_DISMISSAL
];

export const CLICK_FLOW_DATASOURCES = [
  EO_CLICK,
  EO_WEB_TO_APP_AUTO_REDIRECT,
  EO_SMS_SENT,
  EO_INSTALL,
  EO_OPEN,
  EO_REINSTALL
];

export const ATTRIBUTED_TOUCH_DATASOURCES = [
  EO_CLICK,
  EO_WEB_TO_APP_AUTO_REDIRECT,
  EO_SMS_SENT,
  EO_IMPRESSION,
  EO_BRANCH_CTA_VIEW,
  EO_DISMISSAL,
  COST
];
